import { FunctionComponent, useState } from "react";
import BasicCard from "@components/cards/BasicCard";
import BasicDivider from "@components/divider/BasicDivider";
import { Checkbox } from "antd";

interface ContactCardProps {
  children: JSX.Element | string;
  className?: string;
  onCheck: (value: boolean) => void;
}

const ContactCard: FunctionComponent<ContactCardProps> = ({
  children,
  className = "",
  onCheck,
}) => {
  const [checked, setChecked] = useState<boolean>(false);

  const onToggle = () => {
    setChecked(!checked);
    onCheck(!checked);
  };

  return (
    <BasicCard className={`card-contact ${className}`}>
      <>
        <div className="contact-title">Nouveau !</div>
        <div className="contact-description">
          Echangez avec l’expert biométhane GRDF de votre département.{" "}
        </div>
        <BasicDivider variant="grey" height={1} className="w-100 mt-3 mb-3" />
        <Checkbox checked={checked} onChange={onToggle} className="my-10">
          Je souhaite être recontacté par GRDF
        </Checkbox>
        {checked && <div className="contact-content">{children}</div>}
      </>
    </BasicCard>
  );
};

export default ContactCard;
